import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Component, OnInit, Inject,AfterViewInit, ViewChild, ɵConsole, ElementRef, Renderer2 } from '@angular/core';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { Router } from '@angular/router';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {SelectionModel} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs';

import { nkServices } from '../../servicios/app.nkservicios.services';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar'; 
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { HashKeyServices } from '../../servicios/app.hashkey.services';
import { AppUtilService } from '../../servicios/app.util.service';
import { AtributosService } from '../../servicios/atributos.service';
import { ToastNotificationService } from '../../servicios/toast-notification.service';
import { FormmMsgComponent } from '../formm-msg/formm-msg.component';
import { environment } from 'src/environments/environment';
import { StepperSelectionEvent } from '@angular/cdk/stepper';

@Component({
  selector: 'app-form-registro-app',
  templateUrl: './form-registro-app.component.html',
  styleUrls: ['./form-registro-app.component.css']
})
export class FormRegistroAppComponent implements OnInit {
  hide = true;
  nombre:any;
  forma:FormGroup;
  forma_2:FormGroup;
  forma_3:FormGroup;
  forma_4:FormGroup;
  forma_5:FormGroup;
  accion:any;
  archivo:File;
  barra:any = 0;
  des:any;
  logo:any;
  txt_l_1:any;
  txt_l_2:any;
  txt_l_3:any;
  color:any = 'basic';
  b_fami:any;
  b_google:any;
  b_youtu:any;
  b_tik:any;
  b_face:any;
  b_insta:any;
  isLinear = false;
  objectURL:any;
    constructor(
            private render:Renderer2,
            private servicio:nkServices,
            private fb:FormBuilder,
            private dialog: MatDialog,
            private hashkey:HashKeyServices,
            private util:AppUtilService,
            private atrb:AtributosService,
            private router:Router,
            private notifi:ToastNotificationService,
            private dialogRef: MatDialogRef<FormRegistroAppComponent>,
      ///en el injectable llega la informacion del metodo padre en data
      @Inject(MAT_DIALOG_DATA) private data: any) {
        console.log(data, 'primero');
        this.getParametrosApp();
        this.objectURL = this.atrb.IMAGENES_FIJAS.sin_img_log;
          this.accion = data.accion;
        this.forma = fb.group({
          'cod_usuario': [false],
          'estatus': [''],
          /////gerencia
          'cod_unidad':[this.atrb.COD_UNIDAD],
          'des_unidad':[this.atrb.DES_UNIDAD],
          ////dpto
          'cod_dpto':[this.atrb.COD_DPTO],
          'des_dpto':[this.atrb.DES_DPTO],
          ////perfil
          'cod_perfil':[this.atrb.COD_PERFIL_USUARIO],
          'des_perfil':[this.atrb.DES_PERFIL_USUARIO],
          //// rol
          'cod_rol':[this.atrb.USUARIO],
          'des_rol':[this.atrb.DES_USUARIO],
          'mod_usuario': [this.atrb.LICENCIAS.bronce],
          'nom_usuario': ['',[Validators.required, Validators.pattern(this.atrb.EMAILREGEX)]],
          'pass_usuario': ['',[Validators.required]],
          'cpass': ['',[Validators.required,RxwebValidators.compare({ fieldName: 'pass_usuario' })]],
          'f2_1': [''],
          'f3_1': [''],
          'f4_1': [''],
          'f5_1': [''],
          'archivo':[''],
          'formdata':[''],
          'cod_img':[''],
          'cod_empresa':[''],
          'cod_app':[''],
          'operacion': [this.atrb.ACCION_CREAR]
        });
        this.forma_2 = fb.group({
          'f2_1': ['',[Validators.required]],
        });
        this.forma_3 = fb.group({
          'f3_1': ['',[Validators.required]],
        });
        this.forma_4 = fb.group({
          'f4_1': ['',[Validators.required]],
        });
        this.forma_5 = fb.group({
          'f5_1': ['',[Validators.required]],
        });
      }
    ngOnInit(){
          
    }
    ngOnDestroy() {
      URL.revokeObjectURL(this.objectURL);
    }
    async getParametrosApp(){
      try {
        /* await  this.srvc.consultar_sesionhttp(null).toPromise(); */
        let valor = {
          termino: await this.atrb.DEF.toUpperCase(),
          cod_app : await this.hashkey.encrypt(environment.path_token),
          cod_empresa : await localStorage.getItem('cod_empresa'),
          api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicaciones)
        }
        const response = await this.servicio.ApiResthttp(valor).toPromise();
        let img_val;
        for (const i in response) {
          img_val = response[i].constante_app.split('_');
          if (img_val[0].toUpperCase() === await this.atrb.IMG.toUpperCase()) {
            response[i].img = environment.path_storage+response[i].val_def;
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_REG_1.toUpperCase()) {
              this.logo = response[i].img;
            }
          }
          if (img_val[0].toUpperCase() === await this.atrb.TXT.toUpperCase()) {
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_L_1.toUpperCase()) {
              this.txt_l_1 = response[i].val_def;
            }
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_L_2.toUpperCase()) {
              this.txt_l_2 = response[i].val_def;
            }
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_L_3.toUpperCase()) {
              this.txt_l_3 = response[i].val_def;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    async  modalrespuesta(){
      try {
        var accion2 = '';
        var dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:this.data.id_cliente,
                accion:accion2},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if(result !== await this.atrb.CERRAR){
            const formData = new FormData();
            let pass_encritp = await this.hashkey.encrypt(this.forma.value.pass_usuario);
                  formData.append('user_img',this.archivo);
                this.forma.patchValue({
                  cod_empresa:await this.atrb.USUARIO_EMPRESA.usuario_empresa,
                  cod_app : await this.hashkey.encrypt(environment.path_token),
                  pass_usuario:pass_encritp,
                  f2_1: this.forma_2.value.f2_1,
                  f3_1: this.forma_3.value.f3_1,
                  f4_1: this.forma_4.value.f4_1,
                  f5_1: this.forma_5.value.f5_1,
                  formdata:formData
                });
              
              await this.util.cerrarSpinner();
              this.dialogRef.close(this.forma.value);
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
      }
    }
    async cargar_img(xvalor:any){
      try {
        await this.util.abrirSpinner();
        this.objectURL = URL.createObjectURL(xvalor.target.files[0]);
       this.archivo = xvalor.target.files[0];
       
      await this.util.cerrarSpinner();
      } catch (error) {
        await this.util.cerrarSpinner();
        console.log(error);
      }
    }
   async recuperarPass(){
      try {
        let valor = {proceso:await this.atrb.CERRAR}
        this.dialogRef.close(valor);
      } catch (error) {
        console.log(error);
          await this.util.cerrarSpinner();
          await this.notifi.customToastNotification(error.error.message);
      }
    }
    async cerrarmodal(){
      try {
        let accion = 'salir';
        let dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:'',
                accion:accion},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if (result !== await this.atrb.CERRAR) {
            await this.util.cerrarSpinner();
            this.forma.patchValue({
              operacion: await this.atrb.CERRAR
            });
            this.dialogRef.close(this.forma.value);
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        console.log(error);
     }
    }
    async cambiaColor(xvalor:any){
      let inputId = document.querySelector(`#${xvalor}`) as HTMLInputElement;
      let inputClase = document.querySelectorAll('.f2');

            if (inputId.style.backgroundColor === 'rgb(17, 110, 238)') {
              inputClase.forEach(boton =>{
                this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
                });
              inputId.style.backgroundColor = 'rgb(255, 255, 255)';
              inputId.style.color = 'rgb(0, 0, 0)';
                this.forma_2.patchValue({
                  f2_1:''
                });
              return;
            }
            if (inputId.style.backgroundColor === 'rgb(255, 255, 255)') {
                inputClase.forEach(boton =>{
                  this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                  this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
              });
              inputId.style.backgroundColor = 'rgb(17, 110, 238)';
              inputId.style.color = 'rgb(255, 255, 255)';
              this.forma_2.patchValue({
                f2_1:inputId.value
              });
              return;
            }
    }
    async cambiaColor2(xvalor:any){
      let inputId = document.querySelector(`#${xvalor}`) as HTMLInputElement;
      let inputClase = document.querySelectorAll('.f3');

            if (inputId.style.backgroundColor === 'rgb(17, 110, 238)') {
              inputClase.forEach(boton =>{
                this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
                });
              inputId.style.backgroundColor = 'rgb(255, 255, 255)';
              inputId.style.color = 'rgb(0, 0, 0)';
                this.forma_3.patchValue({
                  f3_1:''
                });
              return;
            }
            if (inputId.style.backgroundColor === 'rgb(255, 255, 255)') {
                inputClase.forEach(boton =>{
                  this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                  this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
              });
              inputId.style.backgroundColor = 'rgb(17, 110, 238)';
              inputId.style.color = 'rgb(255, 255, 255)';
              this.forma_3.patchValue({
                f3_1:inputId.value
              });
              return;
            }
    }
    async cambiaColor3(xvalor:any){
      let inputId = document.querySelector(`#${xvalor}`) as HTMLInputElement;
      let inputClase = document.querySelectorAll('.f4');

            if (inputId.style.backgroundColor === 'rgb(17, 110, 238)') {
              inputClase.forEach(boton =>{
                this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
                });
              inputId.style.backgroundColor = 'rgb(255, 255, 255)';
              inputId.style.color = 'rgb(0, 0, 0)';
                this.forma_4.patchValue({
                  f4_1:''
                });
              return;
            }
            if (inputId.style.backgroundColor === 'rgb(255, 255, 255)') {
                inputClase.forEach(boton =>{
                  this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                  this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
              });
              inputId.style.backgroundColor = 'rgb(17, 110, 238)';
              inputId.style.color = 'rgb(255, 255, 255)';
              this.forma_4.patchValue({
                f4_1:inputId.value
              });
              return;
            }
    }
    async cambiaColor4(xvalor:any){
      let inputId = document.querySelector(`#${xvalor}`) as HTMLInputElement;
      let inputClase = document.querySelectorAll('.f5');

            if (inputId.style.backgroundColor === 'rgb(17, 110, 238)') {
              inputClase.forEach(boton =>{
                this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
                });
              inputId.style.backgroundColor = 'rgb(255, 255, 255)';
              inputId.style.color = 'rgb(0, 0, 0)';
                this.forma_5.patchValue({
                  f5_1:''
                });
              return;
            }
            if (inputId.style.backgroundColor === 'rgb(255, 255, 255)') {
                inputClase.forEach(boton =>{
                  this.render.setStyle(boton, 'background-color','rgb(255, 255, 255)');
                  this.render.setStyle(boton, 'color','rgb(0, 0, 0)');
              });
              inputId.style.backgroundColor = 'rgb(17, 110, 238)';
              inputId.style.color = 'rgb(255, 255, 255)';
              this.forma_5.patchValue({
                f5_1:inputId.value
              });
              return;
            }
    }
    async pasos(xvalor:StepperSelectionEvent){
      /* console.log(xvalor); */
      if (xvalor.selectedStep.stepControl.status === 'INVALID') {
        this.barra = this.barra + 20;
      }else{
        if (this.barra > 0 ) {
          this.barra = this.barra - 20;
        }else{
          this.barra = this.barra + 20;
        }
      }
    }
}
